import { EventStatusV2, EventTypeV2 } from "@onair/repositories";

export const DEFAULT_EVENT_BANNER =
	"/assets/images/events/default-event-banner.png";
export const DEFAULT_SECTION_COURSE_BANNER =
	"/assets/images/online-course/section-default.png";
export const DEFAULT_SECTION_COURSE_THUMBNAIL =
	"/host/assets/images/course-thumbnail-default.svg";
export const DEFAULT_HOST_INTRO_BANNER =
	"/assets/images/hosts/host-intro-banner-v2.png";
export const DEFAULT_ACADEMY_THUMBNAIL =
	"/assets/images/onair-academy-thumbnail.svg";

export const SUGGEST_BANNER_LINK =
	"https://support.onair.today/luu-y-khi-thiet-ke-anh-bia-su-kien-tai-onair/";

export const BANNER_ONLINE_COURSE_TEMPLATE_LINK =
	"https://www.canva.com/design/DAGrP58BPtY/J0gILAFMbu3a4WMpnDZDmA/view?utm_content=DAGrP58BPtY&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview";

export enum TabStatus {
	DEFAULT = "DEFAULT",
	VALID = "VALID",
	INVALID = "INVALID",
}

export enum OnlineCourseTab {
	INFORMATION = "INFORMATION",
	CONTENT = "CONTENT",
	PRICING = "PRICING",
}

export enum MediaResourceType {
	VIDEO = "VIDEO",
	PDF = "PDF",
	IMAGE = "IMAGE",
}

export const WALLPAPERS = [
	process.env.NEXT_PUBLIC_WEB_URL +
	"/assets/images/wallpapers/wallpaper-default.png",
	process.env.NEXT_PUBLIC_WEB_URL +
	"/assets/images/wallpapers/wallpaper-cyan.png",
	process.env.NEXT_PUBLIC_WEB_URL +
	"/assets/images/wallpapers/wallpaper-sun.png",
	process.env.NEXT_PUBLIC_WEB_URL +
	"/assets/images/wallpapers/wallpaper-dark-blue.png",
];

export const DEFAULT_WALLPAPER = WALLPAPERS[3];

export const MAPPING_EVENT_TYPE_LABEL: Partial<Record<EventTypeV2, string>> = {
	[EventTypeV2.SINGLE]: "Sự kiện đơn",
	[EventTypeV2.SESSION]: "Sự kiện chuỗi",
};

export const MAPPING_EVENT_STATUS_LABEL: Partial<
	Record<EventStatusV2, string>
> = {
	[EventStatusV2.DRAFT]: "Bản nháp",
	[EventStatusV2.PUBLISHED]: "Đã xuất bản",
	[EventStatusV2.PENDING_APPROVAL_WITH_ADMIN]: "Chờ kiểm duyệt",
	[EventStatusV2.REJECTED]: "Từ chối",
};

export const MAPPING_EVENT_STATUS_LABEL_COLOR: Partial<
	Record<EventStatusV2, string>
> = {
	[EventStatusV2.DRAFT]: "default",
	[EventStatusV2.PUBLISHED]: "primary",
	[EventStatusV2.PENDING_APPROVAL_WITH_ADMIN]: "warning",
	[EventStatusV2.REJECTED]: "error",
};

export const EXCLUDED_FOOTER_ROUTES = [
	"/packages/reskills",
	"/host/online-course/create",
	"/host/online-course/edit",
];

export const MOBILE_EXCLUDED_FOOTER_ROUTES = [
	"/host/online-course/create",
	"/host/online-course/edit",
	"/cart",
];

export enum SignUpTab {
	HOST = "HOST",
	USER = "USER",
}

export const CATEGORY_TREE_CONFIG = {
	ITEMS_LIMIT: 1000,
	QUERY_STALE_TIME: 5 * 60 * 1000, // 5 minutes
	MAX_VISIBLE_ITEMS: 4,
};

export enum UserOnboardingStatus {
	NEW = "NEW",
	USER = "USER",
	NEW_HOST = "NEW_HOST",
	HOST_APPROVED = "HOST_APPROVED",
	HOST_REJECTED = "HOST_REJECTED",
	HOST_RESUBMIT = "HOST_RESUBMIT",
}

export enum RegisterParams {
	EMAIL = "register_email",
	LOGIN_TYPE = "login_type",
	IS_RESUBMITTED_HOST_REGISTRATION = "is_resubmitted_host_registration",
	IS_HOST_REGISTRATION_ACTIVE = "is_host_registration_active",
	HAS_SUBMITTED_HOST_REGISTRATION = "has_submitted_host_registration",
}

export const PERMISSION_DENIED_PATH = "/error/permission-denied";
export const LIFETIME_DATE = "31/12/9999";

export const DEFAULT_RESKILL_AVATAR = "/assets/images/reskills/avatar.png";
export const DEFAULT_RESKILL_PROFILE_URL = "/profile/reskill";

export const DEFAULT_ACADEMY_AVATAR = "/assets/images/academy/avatar.png";
export const DEFAULT_ACADEMY_PROFILE_URL = "/profile/academy";

export const DEFAULT_PLATFORM_AVATAR = "/assets/images/platform/onair.png";
export const DEFAULT_PLATFORM_PROFILE_URL = "/profile/onairplatform";


export const LOW_VALUE_THRESHOLD = 10000;

export const CSMO_EVENT_SLUG = 'csmo-or-vi-mien-trung-2025';
